import { useRef } from "react"
import { useSearchParams } from "react-router-dom"

import Style from "./style"

import DefaultButton from "shared/ui/DefaultButton"

const Search = ({ placeholder }) => {
    const [searchParmas, setSearchParams] = useSearchParams()
    const searchRef = useRef()

    const searchEvent = () => {
        setSearchParams({ "page": 1, "search": searchRef.current?.value })
    }

    return (
        <Style.Wrapper>
            <input placeholder={placeholder} defaultValue={searchParmas.get("search")} ref={searchRef} />
            <DefaultButton small fitWidth expandHeight clickEvent={searchEvent}>검색</DefaultButton>
        </Style.Wrapper>
    )
}

export default Search